'use client'

import type { CreateConnectorFn } from 'wagmi'
import type { InjectedParameters } from 'wagmi/connectors'

import { createConnector } from 'wagmi'
import { injected } from 'wagmi/connectors'

/**
 * Creates a Wagmi connector for browser-injected wallets (e.g., MetaMask).
 * @returns Wagmi connector factory function
 */
export function injectedWalletConnector(): CreateConnectorFn {
  const injectedConfig: InjectedParameters = {
    target: () => ({
      id: 'injected',
      name: 'Browser Wallet',
      provider(window) {
        return window?.ethereum
      }
    })
  }

  return createConnector(config => injected(injectedConfig)(config))
}
